import { runSearchFilterSlice } from '../RunSearchFilterSlice'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('runSearchFilter', runSearchFilterSlice)

export const useRunSearchFilterSlice = (): ReturnType<typeof useGetMethodsAndData> =>
  useGetMethodsAndData()

export default useRunSearchFilterSlice
